/**
 * Info Section Component
 * Reusable section for displaying grouped information
 * Extracted from TeamDetailsModal to eliminate duplication
 */

import React from 'react';

/**
 * Info Section Component
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Section title
 * @param {React.ReactNode} props.children - Section content
 * @param {string} props.titleColor - Title color (default: 'var(--bg)')
 * @param {string} props.backgroundColor - Background color
 * @param {Object} props.style - Additional styles
 * @param {React.ReactNode} props.headerRight - Content to display on right side of header
 */
const InfoSection = ({
    title,
    children,
    titleColor = 'var(--bg)',
    backgroundColor = null,
    style = {},
    headerRight = null
}) => {
    const styles = {
        section: {
            marginBottom: '1.5rem',
            padding: backgroundColor ? '1rem' : '0',
            backgroundColor: backgroundColor || 'transparent',
            borderRadius: backgroundColor ? '8px' : '0',
            ...style
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '0.75rem'
        },
        title: {
            fontSize: '1rem',
            color: titleColor,
            margin: 0,
            fontWeight: '600'
        },
        content: {
            color: 'var(--fg-primary)'
        }
    };

    return (
        <div style={styles.section}>
            <div style={styles.header}>
                <h3 style={styles.title}>{title}</h3>
                {headerRight}
            </div>
            <div style={styles.content}>
                {children}
            </div>
        </div>
    );
};

export default InfoSection;

